import { createContext, useContext } from "react";
import { LoginRequest } from "@/domains/auth";
import { UserPermission, UserRead } from "@/domains/user";

export interface AuthContextType {
  user?: UserRead;
  token?: string;
  isLoggedIn?: boolean;
  isOperator?: boolean;
  login: (payload: LoginRequest) => Promise<void>;
  logout: () => void;
  hasPerm: (perm: UserPermission) => boolean;
}

export const AuthContext = createContext<AuthContextType>(null!);

export const useAuth = () => useContext(AuthContext);
